import { API_BASE_URL } from '../config';

const REDIRECT_STORAGE_KEY = 'googleAuthRedirect';

/** Safe in-app path only — used after Google OAuth to return to /authorize or /mcp/connect. */
export function sanitizeRedirectPath(path) {
    if (!path || typeof path !== 'string') return null;
    if (!path.startsWith('/') || path.startsWith('//')) return null;
    return path;
}

export function stashGoogleAuthRedirect(redirectPath) {
    const safe = sanitizeRedirectPath(redirectPath);
    if (safe) {
        sessionStorage.setItem(REDIRECT_STORAGE_KEY, safe);
    } else {
        sessionStorage.removeItem(REDIRECT_STORAGE_KEY);
    }
    return safe;
}

export function consumeGoogleAuthRedirect(fallbackPath) {
    const fromStorage = sanitizeRedirectPath(sessionStorage.getItem(REDIRECT_STORAGE_KEY));
    if (fromStorage) {
        sessionStorage.removeItem(REDIRECT_STORAGE_KEY);
        return fromStorage;
    }
    return sanitizeRedirectPath(fallbackPath);
}

export function buildGoogleAuthUrl(redirectPath) {
    const safe = stashGoogleAuthRedirect(redirectPath);
    const qs = safe ? `?redirect=${encodeURIComponent(safe)}` : '';
    return `${API_BASE_URL}/auth/google${qs}`;
}

export function startGoogleSignIn(redirectPath) {
    window.location.href = buildGoogleAuthUrl(redirectPath);
}
